import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";

export type VariationFormMessages = ActionButtonMessages & {
  codeLabel: string;
  descriptionLabel: string;

  errorRequiredVariationCode: string;
  errorRequiredVariationDescription: string;

  variationCreateError: string;
  variationUpdateError: string;
  variationErrorToLoad: string;
  variationNotFoundAlt: string;

  variationCreateSuccess: string;
  variationUpdateSuccess: string;
};

export const VARIATION_FORM_MESSAGES: VariationFormMessages = {
  // Labels
  codeLabel: "Código",
  descriptionLabel: "Nome",

  // Error messages
  errorRequiredVariationCode: "O código da variação é obrigatório!",
  errorRequiredVariationDescription: "O nome da variação é obrigatória!",

  variationCreateError: "Erro na criação da variação!",
  variationUpdateError: "Erro ao salvar a variação!",
  variationErrorToLoad: "Erro ao carregar variação",
  variationNotFoundAlt: "Imagem da variação não encontrada",

  // Success messages
  variationCreateSuccess: "Variação criada com sucesso!",
  variationUpdateSuccess: "Variação atualizada com sucesso!",

  ...ACTION_BUTTON_MESSAGES,
};
